
import { Component, Vue } from "vue-property-decorator";
import OrderListItem from "../template/OrderListItem.vue";
import OrderReturnItem from "../template/OrderReturnItem.vue";
import { Getter } from "vuex-class";
import getDate from "@/views/company/getDate";
import {
  getPurchaseOrderListApp,
  updateOrderPayStatus,
  getOrderInfoListApp,
  getReturnOrderList,
  updateOrderStatus,
  OrderParamsDTO,
  OrderListDto,
  getReturnOrderListApp,
  updateReturnOrderStatus,
  OrderReturnParamsDTO,
  OrderReturnDto
} from '@/api/order'
import SearchNav from "@/components/SearchNav/index.vue";

@Component({
  name: 'SearchOrder',
  components: {
    SearchNav,
    OrderListItem,
    OrderReturnItem
  }
})
export default class SearchOrder extends Vue {
  @Getter companyId!: string;
  pageType = "1"; // 1订货单 2退货单
  topType = "1"; // 1销售单 2采购单
  loading = false;
  finished = false;
  refreshing = false;

  value = "";
  placeholder = "输入订单号/客户名称";

  // 查询参数
  params: any = {
    companyId: "",
    startTime: "",
    endTime: "",
    pageIndex: 1,
    pageSize: 10,
    orderId: "", // 订单号/客户名
    returnOrderId: "" // 退单号
  };
  orderList: any = [];

  // 获取列表方法（根据pageType和topType获取订货单或退货单采购单或销售单）
  getOrderFun = getReturnOrderListApp;
  // 修改状态
  updateOrder = updateOrderStatus;

  created () {
    this.params.companyId = this.companyId;

    // 默认查询全部（全部范围是本年）
    var days = getDate.getCurrYearDays();
    this.params.startTime = days.starttime;
    this.params.endTime = days.endtime;
    this.pageType = this.$route.query.pageType as string;
    this.topType = this.$route.query.topType as string;
    if (this.topType == "1" && this.pageType == "1") {
      this.getAuthorityNode();
      this.getOrderFun = getPurchaseOrderListApp;
      this.placeholder = "请输入订单号/客户名称";
    } else if (this.topType == "1" && this.pageType == "2") {
      this.getAuthorityNode();
      this.getOrderFun = getReturnOrderListApp;
      this.placeholder = "请输入退单号/客户名称";
    } else if (this.topType == "2" && this.pageType == "1") {
      this.getOrderFun = getOrderInfoListApp;
      this.placeholder = "请输入订单号/供应商名称";
    } else {
      this.getOrderFun = getReturnOrderList;
      this.placeholder = "请输入退单号/供应商名称";
    }
    this.updateOrder =
      this.pageType == "1" ? updateOrderStatus : updateReturnOrderStatus;
  }

  goBack () {
    console.log("已点击返回事件");
    this.$router.back()
    // if (this.topType == "1") {
    //   this.$router.replace({
    //     path: "/orderManage/salesOrderList"
    //   });
    //   this.pageType == "1"
    //     ? this.$eventBus.$emit("changeToggle", "0")
    //     : this.$eventBus.$emit("changeToggle", "1");
    // } else if (this.topType == "2") {
    //   this.$router.replace({
    //     path: "/orderManage/purchaseOrderList"
    //   });
    //   this.pageType == "1"
    //     ? this.$eventBus.$emit("changeToggle", "0")
    //     : this.$eventBus.$emit("changeToggle", "1");
    // }
  }

  toDetail () {
    this.$router.push("/orderDetail");
  }

  // changeClass(type: string) {
  //     if (type === '1') {
  //         (this.$refs.search as any).classList.add('focus')
  //     } else if (type === '2') {
  //         (this.$refs.search as any).classList.remove('focus')
  //     }
  // }

  getAuthorityNode () {
    if (this.$route.query.authorityNode == "1") {
      this.$set(this.params, "authorityNode", 1);
    } else if (this.$route.query.authorityNode == "2") {
      this.$set(this.params, "authorityNode", 2);
    } else if (this.$route.query.authorityNode == "3") {
      this.$set(this.params, "authorityNode", 3);
    } else if (this.$route.query.authorityNode == "-1") {
      this.$set(this.params, "authorityNode", -1);
    }
    // if(this.$action('updateOrderStatus1')) {
    //   authorityNode = 1
    // } else if (this.$action('updateOrderStatus2')) {
    //   authorityNode = 2
    // } else if (this.$action('updateOrderStatus3')) {
    //   authorityNode = 3
    // }
    // console.log("进来了",this.$route.meta.permission)
    // console.log("进来了",authorityNode)
    // this.$set(this.params,'authorityNode',authorityNode)
  }

  /**
   * @description: 上拉加载更多
   * @param {*}
   * @return {*}
   */
  onLoad () {
    this.params.pageIndex++;
    this.loading = true;
    this.getOrderFun(this.params)
      .then((res) => {
        this.orderList = this.orderList.concat(res.data.records);
        // 加载状态结束
        this.loading = false;
        if (this.orderList.length >= res.data.totalRecords) {
          this.finished = true;
        }
      })
      .finally(() => {
        this.refreshing = false;
      });
  }

  /**
   * @description: 下拉刷新
   * @param {*}
   * @return {*}
   */
  onRefresh () {
    this.params.pageIndex = 1;
    this.refreshing = true;
    this.getOrderList();
  }

  /**
   * @description: 获取订货单/退货单列表
   * @param {*}
   * @return {*}
   */
  getOrderList () {
    this.params.pageIndex = 1;
    if (!this.value) return;
    // 订货单/退货单查询
    this.pageType == "1"
      ? (this.params.orderId = this.value)
      : (this.params.returnOrderId = this.value);
    this.getOrderFun(this.params)
      .then((res) => {
        this.orderList = res.data.records || [];
        if (this.orderList.length >= res.data.totalRecords) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      })
      .finally(() => {
        this.refreshing = false;
      });
  }

  /**
  * @description: 搜索事件
  * @param {*} val
  * @return {*}
  */
  onSearch (val) {
    this.value = val
    this.getOrderList()
  }

  updateStatus (params, tips, operateType) {
    if (operateType !== 8) {
      this.updateOrderStatus(params, tips)
    } else {
      this.updateOrderPayStatus(params, tips)
    }
    this.getOrderList()
  }

  /**
   * @description: 修改订货单/退货单状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderStatus (params, tips) {
    this.updateOrder(params).then((res) => {
      this.$toast({
        type: 'success',
        message: `${tips}成功`,
        duration: 1000,
        onClose: () => {
          // 刷新数据
          this.getOrderList()
        }
      })
    })
  }

  /**
   * @description: 修改订货单付款状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderPayStatus (params, tips) {
    updateOrderPayStatus(params).then((res) => {
      this.$toast({
        type: 'success',
        message: `${tips}成功`,
        duration: 1000,
        onClose: () => {
          // 刷新数据
          this.params.pageIndex = 1
          this.getOrderList()
        }
      })
    })
  }

}
